export default "__VITE_ASSET__WOTA8Pqs__"